import 'owl.carousel';
import helpers from './helpers';
import modal from './modal';
import filter from './filter';
import sidr from './sidr';

global.helpers = helpers;
global.modal = modal;

function initSlider(slider) {
    
    /*
    *   This site uses Owl Carousel
    *   For documentation on events and other options please refer to their documentation
    *   https://owlcarousel2.github.io/OwlCarousel2/
    */
    
    var slider = $(slider);
    if(slider.length) { 
        slider.each(function(id) {
            var customOptions;
            var sliderParams;
            var sliderType = $(this).data('type');
            var isMobile = $(this).data('mobile-only');
            var isSynced = $(this).data('slider-synced');
            
//            console.log(sliderType);
            
            
            // Default options/params for thew slider.
            // Define custom classes to be used for the slider.
            var defaultOptions = {
                nav: true,
                dots: true,
                refreshClass: 'slider__refresh',
                loadedClass: 'slider__loaded',
                loadingClass: 'slider__loading',
                responsiveClass: 'slider__responsive',
                dragClass: 'slider__drag',
                itemClass: 'slider__item',
                stageClass: 'slider__stage',
                stageOuterClass: 'slider__stage-outer',
                grabClass: 'slider__grab',
                autoHeightClass: 'slider__height',
                navContainerClass: 'slider__nav',
                navClass: ['slider__arrow slider__prev', 'slider__arrow slider__next'],
                navText: ['<span class="fal fa-angle-left" aria-label="Previous"></span>', '<span class="fal fa-angle-right" aria-label="Next"></span>'],
                dotClass: 'slider__dot',
                dotsClass: 'slider__dots',
            }

            // Function to determine events for slider that has mobile data attr
            var sliderMobile = function(slider, params) {
                var windowSize = 990;
                
                $(document).ready(function() {
                    if ( $(window).width() < windowSize ) {
                        slider.owlCarousel(params);
                    } else {
                        slider.trigger('destroy.owl.carousel');
                    }
                });

                $(window).resize(function() {
                    if ( $(window).width() < windowSize ) {
                        slider.owlCarousel(params);
                    } else {
                        slider.trigger('destroy.owl.carousel');
                    }
                });
            };
            
            // Function to setup slide accessibility when initialized
            var sliderAccessibility = function(slider, e) {
                slider.find('.slider__item').attr('aria-selected','false');
                slider.find('.slider__item.active').attr('aria-selected','true');

                // apply meta info to next and previous buttons and make them focusable
                slider.find('.slider__prev').attr({
                    role: 'button',
                    title: 'Previous',
                    tabindex: '0',
                });
                slider.find('.slider__next').attr({
                    role: 'button',
                    title: 'Next',
                    tabindex: '0',
                }); 
            };
            
            var sliderSynced = function (slider, syncedNav) {
                syncedNav = $(syncedNav);
                var transitionedFlag = false,
                    duration = 300;

                syncedNav.on("click", ".slider__item", function (e) {
                    e.preventDefault();
                    slider.trigger('to.owl.carousel', [$(this).index(), duration]);
                });

                slider.on('changed.owl.carousel', function (e) {
                    if (!transitionedFlag) {
                        transitionedFlag = true;
                        syncedNav.trigger('to.owl.carousel', [e.item.index, duration]);
                        transitionedFlag = false;
                    }
                });

                syncedNav.on('changed.owl.carousel', function (e) {
                    if (!transitionedFlag) {
                        transitionedFlag = true;
                        slider.trigger('to.owl.carousel', [e.item.index, duration]);
                        transitionedFlag = false;
                    }
                });
            };


            
            // Custom options depending on the data-type atrtribute placed on the '.js-slider' element
            // If no attribute is defined refer to the default case
            switch (sliderType) {
                case 'multi':
                    customOptions = {
                        loop: false,
                        nav: false,
                        items:1,
                        dots: false,
                        margin: 20,
                        stagePadding: 50,
                        responsive : {
                            660 : {
                                items:2,
                                margin: 20,
                                center: false,
                            },
                            990 : {
                                items:3,
                                dots: false,
                                margin: 40,
                                nav: true,
                                stagePadding: 100,
                            },
                            1600 : {
                                items:4,
                                dots: false,
                                margin: 40,
                                nav: true,
                                stagePadding: 100,
                            }
                        }
                    }
                    break;
                case 'nav' :
                    customOptions = {
                        center : false,
                        loop : false,
                        items : 2,
                        margin:10,
                        nav : true,
                        dots: false,
                    }
                    break;
                case 'hero' :
                    customOptions = {
                        items: 1,
                        margin: 0,
                        autoHeight: true,
                        stagePadding: 0,
                        loop: true,
                        autoplay: true,
                        autoplayTimeout: 5000,
                        autoplayHoverPause: false,
                        navClass: [ 'slider__btn slider__prev', 'slider__btn slider__next' ],
                    }
                    break;
                default:
                    customOptions = {
                        items: 1,
                        margin:0,
                        autoHeight:true,
                        stagePadding: 0,
                        navClass: [ 'slider__btn slider__prev', 'slider__btn slider__next' ],
                    }
                    break;
            }

            //Merge the default settings with the custom settings from each slide type
            sliderParams = $.extend(true, defaultOptions, customOptions);

            // Add class based on the type of slider for any extra stying needs
            if(sliderType) {
                $(this).addClass('slider--' + sliderType);   
            } else {
                $(this).addClass('slider--default');
            }

            $(this).on('translated.owl.carousel', function(event) {                
                // Change the aria attributes after the slider has finished animation
                $(this).find('.slider__item').attr('aria-selected','false');
                $(this).find('.slider__item.active').attr('aria-selected','true');
            });
            
            // Call functions to add accessibility once the slider has initialized or changed
            $(this).on('initialized.owl.carousel', function() {
                sliderAccessibility($(this));
            });
            
            if(isSynced !== undefined) {
                sliderSynced($(this), isSynced);
            }
            
            // If slider has data-mobile-only init and destroy slider based on breakpoint 
            // otherwise init slider with settings from merge
            if(isMobile !== undefined) {
                sliderMobile($(this), sliderParams);
            } else {
                $(this).owlCarousel(sliderParams);
            }
            
        });
        
        return $(this);
    }
}

function initMobileMenu(trigger, close, menu, canvas) {
    trigger = $(trigger);
    close = $(close);
    menu = $(menu);
    canvas = $(canvas);

    trigger.attr({
        'role': 'button',
        'aria-expanded': 'false'
    });

    menu.attr({
        'aria-hidden': 'true',
        'tabindex': '-1'
    });

    trigger.on('click', function (e) {
        e.preventDefault();
        $(this).toggleClass('is-active');
        menu.toggleClass('is-active');
        canvas.toggleClass('is-active');
        $('html, body').toggleClass('no-scroll');
    });
    
    close.on('click', function (e) {
        e.preventDefault();
        menu.removeClass('is-active');
        canvas.removeClass('is-active');
        $('html, body').removeClass('no-scroll');
    });
}

function offsetHeader(header, offsetWrap) {
    var height = $(header).outerHeight(true);
    $(offsetWrap).css('margin-top', height);
}

$(document).ready(function () {
    initSlider('.js-slider');
//    initMobileMenu('.js-mob-menu-trigger', '.js-mob-menu-close', '.js-mob-menu', '.js-menu-canvas');
    modal.initModal('.js-modal-gallery');
    offsetHeader('.header', '.js-header-offset');
    filter.initFilter('#filter', '#filter-response');
    filter.initFilter('#articlefilter', '#articlefilter-response');
    
    $('a[href*="#"]').on('click', function(e) {
        e.preventDefault();
        $('body, html').animate({scrollTop: $($(this).attr('href')).offset().top - 70}, 'slow');
    });
    
    
    $('.resource__toc.mobile').find('.resource__toc--toggle').on('click', function() {
        $(this).next().slideToggle('fast');
        $(this).toggleClass('active');
    });
    $('.resource__toc.mobile').find('a').on('click', function() {
        $('.resource__toc--toggle').next().slideToggle('fast');
        $('.resource__toc--toggle').toggleClass('active');
    });
    
    $("#refresh").click(function() { 
          document.getElementById('articlefilter').reset(); 
    });
    
    //Sidr
    $('#mobile-trigger').sidr({
        side: 'right',
        name: 'sidr',
        displace: false,
        source : function() {
            var sidrHtml;

            sidrHtml = '<div id="mobile-menu">';

            sidrHtml += '<span class="sidr__close" aria-label="Close Menu">Close Menu</span>';
//            sidrHtml += '<div class="sidr__logo">' + $('.header__logo').html() + '</div>';

            sidrHtml += '<div class="sidr__inner">';

            sidrHtml += '<div class="sidr__mainnav">' + $('.main-navigation').html() + '</div>';

            sidrHtml += '</div>';
            sidrHtml += '</div>';

            return sidrHtml;
        },
        onOpen: function() {
            //alert('test');
            $( 'body' ).prepend( '<div class="sidr-overlay"></div>' );
        },
        onOpenEnd: function(){
            $( 'body' ).css({
                "position": "fixed",
                "left": "0",
                "top": "0",
                "width": "100%"
            });
        },
        onClose: function(){
            $( '.sidr-overlay' ).remove();
        },
        onCloseEnd: function(){
            $( 'body' ).css({
                "position": "relative",
                "left": "auto",
                "top": "auto",
                "width": "100%"
            });
        }
    });
    $('.menu-item-has-children .arrow').click(function(e) {
        e.preventDefault();
        $(this).toggleClass('active').next().slideToggle();
    });
    $('.sidr__close').click(function() {
        $.sidr('close','sidr');
    });
    
    
    $('.js-modal-iframe').modaal({
        type: 'iframe',
        width: 700,
        height: 500
    });
});


// WEBPACK FOOTER //
// ./src/js/app.js